import { useState } from 'react';
import { Collapse } from 'reactstrap';
import MeasurementUnits from '../../../Layout/MeasurementUnits';
import { useAppContext } from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

const DayPlanIngredient = ({
  name,
  measurements,
  hasReplacement,
  originalProductId,
  productId,
  mealType,
  children,
}) => {
  const { trackFirebaseEvent } = useOutletContext();
  const [collapse, setCollapse] = useState(false);

  const {
    images: { changeButton, iconChangeDone2 },
  } = useAppContext();

  const closeAndScroll = () => {
    setCollapse(false);
  };

  const handleClick = () => {
    trackFirebaseEvent('user_action', {
      action: 'tap-change_ingredient',
      location: 'Meal_details',
      firebase_screen: 'Meal_details',
      meal_id: productId,
      meal_category: mealType,
    });

    setCollapse(!collapse);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li onClick={() => handleClick()} data-test="ingredient">
      <MeasurementUnits measurements={measurements} />
      <span className="stay-together">
        {hasReplacement ? (
          <button
            type="button"
            className={
              collapse
                ? 'btn-change animate__animated rotateLeft'
                : 'btn-change animate__animated rotateRight'
            }
            data-test="exchange-button"
          >
            <img
              className="img-fluid"
              src={originalProductId !== productId ? iconChangeDone2 : changeButton}
              alt=""
            />
          </button>
        ) : (
          ''
        )}
      </span>
      {name}

      <Collapse isOpen={collapse}>
        {hasReplacement
          ? children({
              closeAndScroll: () => closeAndScroll(),
            })
          : ''}
      </Collapse>

      <div className="clearfix" />
    </li>
  );
};

export default DayPlanIngredient;
